import { render, staticRenderFns } from "./batchEdit.vue?vue&type=template&id=9fd2084a&scoped=true"
import script from "./batchEdit.vue?vue&type=script&lang=js"
export * from "./batchEdit.vue?vue&type=script&lang=js"
import style0 from "./batchEdit.vue?vue&type=style&index=0&id=9fd2084a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd2084a",
  null
  
)

export default component.exports